import { z } from 'zod'
import { monosanFetch } from '@/shared/api/monosanFetch'

const balanceSchema = z.object({
  accountId: z.string(),
  accountIban: z.string(),
  availableAmount: z.object({
    value: z.number(),
    currency: z.string(),
  }),
})

export type Balance = z.infer<typeof balanceSchema>

export const getBalance = (): Promise<Balance> =>
  monosanFetch('/api/accounts/preferred/balance', {
    schema: balanceSchema,
  })
